'use client';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { useTargetPerpMarketAccount } from './useTargetMarketAccount';

const useCurrentPerpMarketAccount = () => {
	const currentMarketId = useVelocityStore(
		(s) => s.selectedMarket.current?.marketId
	);
	return useTargetPerpMarketAccount(currentMarketId);
};

export default useCurrentPerpMarketAccount;
